import { StepHandle } from "..";
import { modelStepService, WorkflowManager } from "../..";
import { ModelStepData, Step } from "../../types";
import { Variant } from "../resource/variant";

export class ModelStepHandle extends StepHandle<ModelStepData> {
    constructor(manager: WorkflowManager, step: Step<ModelStepData>, tags: string[]) {
        super(manager, step, tags);
    }

    selectVariant(variant: Variant) {
        return modelStepService.selectVariant(this.step, variant.getResource(), this.manager, (v) =>
            this.setUpdateState(v),
        );
    }
}
